"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LEGACY_TYPES = exports.ScriptFormatMap = exports.AlignmentTypeMap = exports.NodeGroupMap = exports.MarkTypeMap = exports.NodeTypeMap = void 0;
const SCREENPLAY = 'screenplay';
const VARIETY = 'variety';
const CLASSIC = 'classic';
const DOC = 'doc';
const PAGE = 'page';
const TEXT = 'text';
const HARD_BREAK = 'hard_break';
const GENERAL = 'general';
const NEW_ACT = 'new_act';
const END_OF_ACT = 'end_of_act';
const CHARACTER = 'character';
const DIALOGUE = 'dialogue';
const PARENTHETICAL = 'parenthetical';
const ACTION = 'action';
const SCENE_HEADING = 'sceneHeading';
const TRANSITION = 'transition';
const SLUG = 'slug';
const BRACKET = 'bracket';
const DUAL_DIALOGUE = 'dual_dialogue';
const DUAL_DIALOGUE_COLUMN = 'dual_dialogue_column';
const STRONG = 'strong';
const EM = 'em';
const UNDERLINE = 'underline';
const LINK = 'link';
const COMMENT = 'comment';
const STRIKE = 'strike';
const BLOCK = 'block';
const INLINE = 'inline';
const ALIGN_LEFT = 'left';
const ALIGN_CENTER = 'center';
const ALIGN_RIGHT = 'right';
exports.NodeTypeMap = {
    DOC,
    PAGE,
    TEXT,
    HARD_BREAK,
    GENERAL,
    NEW_ACT,
    END_OF_ACT,
    CHARACTER,
    DIALOGUE,
    PARENTHETICAL,
    ACTION,
    SCENE_HEADING,
    TRANSITION,
    SLUG,
    BRACKET,
    DUAL_DIALOGUE,
    DUAL_DIALOGUE_COLUMN,
};
exports.MarkTypeMap = {
    STRONG,
    EM,
    UNDERLINE,
    LINK,
    COMMENT,
    STRIKE,
};
// groups
exports.NodeGroupMap = { BLOCK, INLINE };
// alignment
exports.AlignmentTypeMap = {
    ALIGN_LEFT,
    ALIGN_RIGHT,
    ALIGN_CENTER,
};
// script formats
exports.ScriptFormatMap = { SCREENPLAY, VARIETY, CLASSIC };
// export all to support the legacy `types` from this library. Newer clients should
// prefer the categorized and typed exports above
exports.LEGACY_TYPES = {
    SCREENPLAY,
    VARIETY,
    CLASSIC,
    DOC,
    PAGE,
    TEXT,
    HARD_BREAK,
    GENERAL,
    NEW_ACT,
    END_OF_ACT,
    CHARACTER,
    DIALOGUE,
    PARENTHETICAL,
    ACTION,
    SCENE_HEADING,
    TRANSITION,
    SLUG,
    BRACKET,
    DUAL_DIALOGUE,
    DUAL_DIALOGUE_COLUMN,
    STRONG,
    EM,
    UNDERLINE,
    LINK,
    COMMENT,
    STRIKE,
    BLOCK,
    INLINE,
    ALIGN_LEFT,
    ALIGN_CENTER,
    ALIGN_RIGHT,
};
